var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21875 0.324219H1.43481H5L9.1333 6.34717L14.302 0.324219H15.6458L9.72449 7.20874L15.5325 15.6719L16.2188 16.6719H15.0059H11.5312L7.09692 10.2639L1.58325 16.6743H0.270752L6.50549 9.40918L0.910767 1.32422L0.21875 0.324219ZM12.0553 15.6719L2.12683 1.32422H4.47339L14.3197 15.6719H12.0553Z",
    fill: "#B1924C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.31c3d7b137b1183f52f3e7b986c39e4d.svg";
export { ForwardRef as ReactComponent };